import React from "react";
import { FiChevronDown } from "react-icons/fi";

const SelectBox = ({ value, setValue,className, options = [], placeholder = "Select...", onSelect }) => {
  const handleChange = (e) => {
    const val = e.target.value;
    setValue(val);
    if (onSelect) onSelect(val);
  };

  const isActive = value && value !== "";

  return (
    <div className={className? `relative w-full lg:max-w-xs ${className}`: "relative w-full lg:max-w-xs "}>
      <select
        value={value}
        onChange={handleChange}
        title="Click to view options"
        className={`w-full appearance-none cursor-pointer  px-3 py-2 border border-quaternary/40 rounded-lg bg-quaternary/20 text-gray-700 outline-none shadow-sm ${
          isActive ? "border-quaternary" : "border-gray text-gray-400"
        }`}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <FiChevronDown
        size={20}
        className={`absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none ${
          isActive ? "text-quaternary" : "text-gray-400"
        }`}
      />
    </div>
  );
};

export default SelectBox;
